/**
 * The brand's words, from `brand_assets/brand.json`.
 *
 * GENERATED by `scripts/build_tokens.py` — do not edit. `--check` runs
 * in CI, so a name or a tagline changed in `brand.json` and not here
 * fails the build rather than shipping an application that disagrees
 * with its own deliverables.
 */

export const BRAND = {
  name: "Assay",
  tagline: "evidence-bound insights",
} as const;
